import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-plants-list" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "p-input-icon-left p-input-icon-custom ml-auto mr-3 mr-xl-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = {
  id: "navigation-wrp",
  class: "d-flex align-items-baseline justify-content-between mt-4"
}
const _hoisted_7 = { id: "dropdowns-wrp" }
const _hoisted_8 = { class: "layout-plants-hub__content" }
const _hoisted_9 = {
  key: 0,
  class: "plants-list plants-list__cards"
}
const _hoisted_10 = {
  key: 1,
  class: "py-5 text-center"
}
const _hoisted_11 = { class: "fs-18 text-gray" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  id: "paginator-wrapper",
  class: "mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Button = _resolveComponent("Button")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_PlantCardV2 = _resolveComponent("PlantCardV2")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_DialogPlantDuplicate = _resolveComponent("DialogPlantDuplicate")
  const _component_DialogPlantCreate = _resolveComponent("DialogPlantCreate")
  const _component_DialogConfirmDeletePlant = _resolveComponent("DialogConfirmDeletePlant")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Plants")), 1),
      _createVNode("span", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          type: "text",
          placeholder: _ctx.$t('AppResource.SearchByPlantName'),
          modelValue: _ctx.searchTerm,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTerm = $event)),
          onInput: _ctx.handleSearch
        }, null, 8, ["placeholder", "modelValue", "onInput"])
      ]),
      _createVNode(_component_Divider, { layout: "vertical" }),
      _createVNode(_component_Button, {
        class: "p-button-rounded p-button-raised p-button--m",
        onClick: _ctx.toggleCreateDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.NewPlant")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_TabView, {
        class: "p-tabview--custom",
        onTabChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTabClick($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResource.All')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('general.favourites')
          }, null, 8, ["header"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_Dropdown, {
          options: _ctx.filterByOptions,
          modelValue: _ctx.selectedFilterBy,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedFilterBy = $event)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFilterByChange($event))),
          optionLabel: "label",
          optionValue: "value",
          class: "plants-list__filter ml-auto mr-4 w-100"
        }, null, 8, ["options", "modelValue"]),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.orderBy,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.orderBy = $event)),
          options: _ctx.orderByOptions,
          optionLabel: "label",
          optionValue: "value",
          class: "plants-list__filter ml-auto w-100"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.hasPlants)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedPlants, (plant, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "plants-list__card",
                      key: `card-plant-${i}`
                    }, [
                      _createVNode(_component_PlantCardV2, {
                        plant: plant,
                        onEdit: () => _ctx.handleEditPlant(plant),
                        onDuplicate: () => _ctx.handleDuplicatePlant(plant),
                        onDelete: () => _ctx.toggleDeletePlantConfirm(plant)
                      }, null, 8, ["plant", "onEdit", "onDuplicate", "onDelete"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_10, [
                  (!_ctx.wasSearchExecuted)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("h1", null, _toDisplayString(_ctx.$t("AppResource.NoPlantsUpper")), 1),
                        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("plants.noPlantsHint")), 1)
                      ], 64))
                    : (_openBlock(), _createBlock("h1", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.NoPlantsUpper")), 1))
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!!_ctx.selectedPlants && _ctx.selectedPlants.length)
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode(_component_Paginator, {
            totalRecords: _ctx.totalPlants,
            rows: _ctx.pageSize,
            currentPageReportTemplate: '{first} - {last} of {totalRecords}',
            class: "p-0",
            onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handlePageChange($event)))
          }, null, 8, ["totalRecords", "rows"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DialogPlantDuplicate, {
      onFetchPlants: _ctx.refreshList,
      onHideDialog: _ctx.handleHideDialog,
      plant: _ctx.plantUnderDuplication,
      "is-visible": _ctx.isPlantDuplicateDialogVisible
    }, null, 8, ["onFetchPlants", "onHideDialog", "plant", "is-visible"]),
    _createVNode(_component_DialogPlantCreate, {
      "is-visible": _ctx.isVisibleCreateDialog,
      "edit-plantId": _ctx.selectedPlantId,
      "edit-plantType": _ctx.selectedPlantType,
      onPlantEdited: _ctx.refreshList,
      onHideDialog: _ctx.toggleCreateDialog
    }, null, 8, ["is-visible", "edit-plantId", "edit-plantType", "onPlantEdited", "onHideDialog"]),
    _createVNode(_component_DialogConfirmDeletePlant, {
      "is-visible": _ctx.isVisibleDeletePlantConfirm,
      "plant-name": _ctx.plantToDeleteName,
      onHideDialog: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleDeletePlantConfirm(null))),
      onConfirm: _ctx.handleDeletePlant
    }, null, 8, ["is-visible", "plant-name", "onConfirm"])
  ]))
}